export const SET_INSPECCIONES = "accionSetInspecciones";

export const setInspecciones = (inspecciones) => ({
  type: SET_INSPECCIONES,
  inspecciones: Array.from(inspecciones),
});
